import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18025a02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-start ga-2" }
const _hoisted_2 = { class: "text-body-1 font-weight-bold nombre flex-grow-1" }
const _hoisted_3 = { class: "text-caption text-medium-emphasis" }
const _hoisted_4 = {
  key: 0,
  class: "text-caption mt-1"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-medium-emphasis" }, " · ", -1))
const _hoisted_6 = {
  key: 1,
  class: "text-caption text-medium-emphasis mt-1"
}
const _hoisted_7 = { class: "d-flex ga-1 mt-3" }

import { computed } from "vue";
import { esPorJornadas, nombreEvento, textosEvento } from "@/Constant/FormatoTorneo";
import { tipoTorneoOptions } from "@/Constant/TiposTorneo";
import { formatFechaSpaWhitoutAsync } from "@/utils/Fecha";
import { estadoLista } from "@/utils/estadoLista";
import {
  estaEnCurso,
  haTerminado,
  MiInscripcion,
  primerDia,
  ultimoDia,
} from "@/utils/misEventos";


export default /*#__PURE__*/_defineComponent({
  __name: 'TarjetaInscripcion',
  props: {
    inscripcion: {}
  },
  emits: ["verInscripcion"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const terminado = computed(() => haTerminado(props.inscripcion));
const enCurso = computed(() => estaEnCurso(props.inscripcion));

const fechas = computed(() => {
  const inicio = primerDia(props.inscripcion);
  const fin = ultimoDia(props.inscripcion);
  return fin > inicio
    ? `Del ${formatFechaSpaWhitoutAsync(inicio)} al ${formatFechaSpaWhitoutAsync(fin)}`
    : formatFechaSpaWhitoutAsync(inicio);
});

const tipo = computed(
  () =>
    tipoTorneoOptions.find(t => t.value === props.inscripcion.torneo.tipoTorneo)?.label ??
    props.inscripcion.torneo.tipoTorneo
);

const lista = computed(() => estadoLista(props.inscripcion.estadoLista));
const pagado = computed(
  () => props.inscripcion.esPago === true || String(props.inscripcion.esPago).toUpperCase() === "SI"
);

const textoResultados = computed(() =>
  esPorJornadas(props.inscripcion.torneo.formatoTorneo)
    ? `Ver ${textosEvento(props.inscripcion.torneo.formatoTorneo).el}`
    : "Resultados"
);
// Los resultados están en el evento, en su pestaña
const rutaResultados = computed(() => `/detalle-evento/${props.inscripcion.idTorneo}?tab=resultados`);

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    variant: "outlined",
    class: "pa-3 h-100 d-flex flex-column text-left"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.inscripcion.torneo.nombreTorneo), 1),
        (enCurso.value)
          ? (_openBlock(), _createBlock(_component_v_chip, {
              key: 0,
              size: "x-small",
              color: "success",
              variant: "tonal",
              class: "flex-shrink-0 mt-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" En curso ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(fechas.value) + " · " + _toDisplayString(_unref(nombreEvento)(_ctx.inscripcion.torneo.formatoTorneo)) + " · " + _toDisplayString(tipo.value), 1),
      (!terminado.value && _ctx.inscripcion.estadoLista)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass(`text-${lista.value.color}`)
            }, _toDisplayString(lista.value.texto), 3),
            _hoisted_5,
            _createElementVNode("span", {
              class: _normalizeClass(pagado.value ? 'text-success' : 'text-warning')
            }, _toDisplayString(pagado.value ? "Pagado" : "No pagado"), 3)
          ]))
        : _createCommentVNode("", true),
      (_ctx.inscripcion.ejercitoElegido)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.inscripcion.ejercitoElegido), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_v_spacer),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_btn, {
          size: "small",
          variant: "tonal",
          class: "accion text-none",
          to: `/detalle-evento/${_ctx.inscripcion.idTorneo}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Ver evento ")
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_v_btn, {
          size: "small",
          variant: "tonal",
          class: "accion text-none",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('verInscripcion', _ctx.inscripcion)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Inscripción ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          size: "small",
          variant: "tonal",
          class: "accion text-none",
          to: rutaResultados.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(textoResultados.value), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _: 1
  }))
}
}

})